import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    stisLoading : false,
    serviceType: [],
    totalServiceType: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    stiscLoading:false,
    stcstatus:"",
    stcMessage:"",
    stdetails:{},
    stismloading:false,
    stmstatus:"",
    stmmessage:"",
    stSDetails: {},
    stdstatus:"",
    stdmessage:"",
    error:"",
    
};


const serviceTypeSlice = createSlice({
    name: "serviceTypiesList",
    initialState,
    reducers:{
        getServiceTypePending: (state) => {
            state.stisLoading = true;
        },
        getServiceTypeSuccess: (state, { payload }) => {
            state.stisLoading = false;
            state.serviceType = payload;
            state.stdetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getServiceTypeFail: (state, { payload }) => {
            state.stisLoading = false;
            state.error = payload;
        },
        createServiceTypePending:(state,action) => {
            state.stiscLoading=true;
        },
        createServiceTypeSuccess:(state,{payload}) => {
            state.stiscLoading=false;
            state.stcstatus="success";
            state.stcMessage=payload;
        },
        createServiceTypeFail:(state,{payload}) => {
            state.stiscLoading=false;
            state.stcstatus="fail";
            //console.log('slice '+payload);
            state.stcMessage=payload;
        },
        getSServiceTypePending: (state) => {
            state.stisLoading = true;
        },
        getSServiceTypeSuccess: (state, { payload }) => {
            state.stisLoading = false;
            state.stSDetails=payload;
           
           // state.user="slice userData";
            state.error = '';
        },
        getSServiceTypeFail: (state, { payload }) => {
            state.stisLoading = false;
            state.error = payload;
        },
        modifyServiceTypePending:(state,action) => {
            state.stismloading=true;
            state.stmstatus="";
        },
        modifyServiceTypeSuccess:(state,{payload}) => {
            state.stismloading=false;
            state.stmstatus="success";
           
            state.stmmessage="Service Successfully Updated";
        },
        modifyServiceTypeail:(state,{payload}) => {
            state.stismloading=false;
            state.stmstatus="fail";
           // console.log('slice '+payload);
            state.stmmessage=payload;
        },
        deleteServiceTypePending:(state,action) => {
            state.stisloading=true;
            state.stdstatus="";
        },
        deleteServiceTypeSuccess:(state,{payload}) => {
            state.stisLoading=false;
            state.stdstatus="success";
            state.stdmessage="Service Successfully Deleted";
        },
        deleteServiceTypeFail:(state,{payload}) => {
            state.stisLoading=false;
            state.stdstatus="fail";
           // console.log('slice '+payload);
            state.stdmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = serviceTypeSlice;

export const { getServiceTypePending, getServiceTypeSuccess, getServiceTypeFail,getSServiceTypePending, getSServiceTypeSuccess, getSServiceTypeFail, 
    createServiceTypePending, createServiceTypeSuccess, createServiceTypeFail,
    modifyServiceTypePending,modifyServiceTypeSuccess,modifyServiceTypeFail,
    deleteServiceTypePending,deleteServiceTypeSuccess,deleteServiceTypeFail  } = actions;

export default reducer;
